module.exports = __webpack_public_path__ + "img/4.6c8d5c4a.jpg";